import React, {useEffect, useState} from 'react';
import {cs, de, enGB, sk} from 'date-fns/locale'
import {format} from 'date-fns';
import moment from 'moment';

import '../../react-calendar/src/styles.scss'; // main style file
import '../../react-calendar/src/theme/default.scss'; // theme css file
import {DateRange} from '../../react-calendar/src/components/DateRange/index.js';

import OfficeSelector from "@/modules/front/OfficeSelector";
import VariantSelector from "@/modules/front/VariantSelector";


const ItemDatePicker = (props) => {

    const [deviceSize, changeDeviceSize] = useState(window.innerWidth);
    const [possibleLengths, setPossibleLengths] = useState(null);
    const [allowNext, setAllowNext] = useState(false);
    const [disabledDates, setDisabledDates] = useState([]);
    const [partlyDisabledDates, setPartlyDisabledDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [disabledDatesCache, setDisabledDatesCache] = useState([]);
    const [shownDate, setShownDate] = useState(new Date());
    const [officeId, setOfficeId] = useState(props.office);
    const [productId, setProductId] = useState(window.variables.entityId);

    const minLength = 1;
    const lockOffice = props.lockOffice;

    const [state, setState] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    useEffect(() => {
        if (state && state.startDate && state.endDate) {
            const length = moment(state.endDate).diff(moment(state.startDate), 'days') + 1;
            if (length < minLength) {
                setState({
                    startDate: state.startDate,
                    endDate: moment(state.startDate).add(minLength - 1, 'days').toDate(),
                    key: 'selection',
                });
            }
        }
    }, [state.startDate, state.endDate]);

    useEffect(() => {
        const resizeW = () => changeDeviceSize(window.innerWidth);
        window.addEventListener("resize", resizeW); // Update the width on resize
        return () => window.removeEventListener("resize", resizeW);
    });

    let variants = [];
    if (props.variants && props.variants.length > 0) {
        for (var i in props.variants) {
            variants.push(props.variants[i]);
        }
    }


    const fetchCalendarData = (startMonth, refresh = false) => {

        // Do not return to range focus if user is changing month
        if (startMonth) {
            setShownDate(moment(startMonth).toDate());
        }

        if (startMonth) {
            var month = moment(startMonth).format('YYYY-MM');
            const nextMonth = moment(startMonth).add(1, 'months').format('YYYY-MM');

            if (disabledDatesCache.includes(month)) {
                if (disabledDatesCache.includes(nextMonth)) {
                    return;
                }
            }
        } else {
            var month = moment().format('YYYY-MM');
        }


        setLoading(true);

        const endPoint = window.api.product.getCalendarData;
        const url = endPoint + '?productId=' + productId + '&dateFrom=' + month + '&officeId=' + officeId;

        fetch(url)
            .then(response => response.json())
            .then(data => {
                var dd = data.disabledDates.map(function (date) {
                    let d = new Date(date)
                    // Set time to 00:00:00 - possible bug in react-calendar
                    d.setHours(0, 0, 0, 0);
                    return d;

                });

                var pdd = data.partlyDisabledDates.map(function (date) {
                    return date;
                });

                if (refresh) {
                    setDisabledDatesCache([...data.months]);
                    setDisabledDates([...dd]);
                    setPartlyDisabledDates([...pdd]);
                } else {
                    setDisabledDatesCache([...disabledDatesCache, ...data.months]);
                    setDisabledDates([...disabledDates, ...dd]);
                    setPartlyDisabledDates([...partlyDisabledDates, ...pdd]);
                }
                setLoading(false);
            });
    }

    useEffect(() => {
        fetchCalendarData();
    }, []);

    useEffect(() => {
        fetchCalendarData(null, true);
    }, [productId]);


    // Get possible lengths
    useEffect(() => {
        if (state && state.startDate) {
            const endPoint = window.api.product.getMaxReservationLength;
            const url = endPoint + '?productId=' + productId + '&date=' + moment(state.startDate).format('YYYY-MM-DD') + '&officeId=' + officeId;

            if (!state.startDate) return;

            setPossibleLengths(null);
            setLoading(true);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    setPossibleLengths(data.possibleLengths);
                    setLoading(false);
                });
        }
    }, [state.startDate, officeId]);


    useEffect(() => {
        if (possibleLengths) {
            if (state && state.endDate && state.startDate) {
                const length = moment(state.endDate).diff(moment(state.startDate), 'days') + 1;

                if (possibleLengths.length == 0 || !possibleLengths.includes(length)) {
                    setAllowNext(false);
                } else {
                    setAllowNext(true);
                }
            }
        }
    }, [possibleLengths]);

    useEffect(() => {
        fetchCalendarData(null, true);
    }, [officeId]);

    useEffect(() => {
        if (props.onChange) {
            props.onChange({
                allowNext: allowNext, startDate: state.startDate, endDate: state.endDate
            })
        }
    }, [allowNext, state.startDate, state.endDate]);
    // End get possible lengths

    const handleVariantChange = (variant) => {
        setProductId(variant);
    };

    var someInfo = null;
    if (!officeId) {
        someInfo = <>
            <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice}
                            onOfficeChange={(o) => handleOfficeChange(o)}/>
            <div className="">
                <div
                    className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row w-100'>
                    <PriceInfo startDate={state.startDate} endDate={state.endDate} productId={productId}/>
                    <AddToCartButton disabled={true} addToCartLabel={props.addToCartLabel}
                                     onDateConfirmed={props.onDateConfirmed} productId={productId}/>
                </div>
            </div>
        </>

    } else {
        someInfo = allowNext ? (<>
                <div>
                    <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice}
                                    onOfficeChange={(o) => handleOfficeChange(o)}/>
                    <VariantSelector variants={variants} variant={productId} onVariantChange={handleVariantChange}/>
                </div>
                <div
                    className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row w-100'>
                    <PriceInfo startDate={state.startDate} endDate={state.endDate} officeId={officeId}
                               productId={productId}/>
                    <AddToCartButton startDate={state.startDate} endDate={state.endDate} officeId={officeId}
                                     addToCartLabel={props.addToCartLabel} onDateConfirmed={props.onDateConfirmed}
                                     productId={productId}/>
                </div>
            </>

        ) : (<>
                <div>
                    <OfficeSelector offices={props.offices} office={props.office} lockOffice={lockOffice}
                                    onOfficeChange={(o) => handleOfficeChange(o)}/>
                    <VariantSelector variants={variants} variant={productId} onVariantChange={handleVariantChange}/>
                </div>
                <div
                    className='d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row'>
                    <div className='text-danger' style={{marginRight: "1em"}}>{window.translations.notAvailable}</div>
                    <AddToCartButton disabled={true} addToCartLabel={props.addToCartLabel}
                                     onDateConfirmed={props.onDateConfirmed} productId={productId}/>
                </div>
            </>

        );
    }


    const customDayContent = (day) => {
        var className = "";
        if (partlyDisabledDates.includes(moment(day).format('YYYY-MM-DD'))) {
            className = "partly-disabled";
        }
        return (<div className={className}>
                <span>{format(day, "d")}</span>
            </div>)
    }

    let className = loading ? 'componentLoading' : '';
    let locale = null;
    if (props.locale == 'en' || props.locale == 'en_EN') {
        locale = enGB;
    } else if (props.locale == 'de' || props.locale == 'de_DE') {
        locale = de;
    } else if (props.locale == 'sk' || props.locale == 'sk_SK') {
        locale = sk;
    } else {
        locale = cs;
    }

    const handleOfficeChange = (office) => {
        setOfficeId(office.id);
    }
    // Get bs primary color
    let color_ = getComputedStyle(document.documentElement).getPropertyValue('--bs-primary');
    const [color, setColor] = useState(color_);

    window.addEventListener('load', () => {
        setColor(getComputedStyle(document.documentElement).getPropertyValue('--bs-primary'));
    });

    if (!officeId) {
        className += ' disabled-choose-office';
    }


    return (<div className={className}>
            <div
                className="legend d-flex justify-content-md-end justify-content-center align-items-center flex-column flex-md-row mb-3">
                <div className="d-flex align-items-center py-1 me-1">
                    <div className="freeDay border px-2">
                        <small>1</small>
                    </div>
                    <div className="px-2">
                        <small>{window.translations.calendarLegend.free}</small>
                    </div>
                </div>
                <div className="d-none align-items-center py-1 me-1 weekendDayLegendWrapper">
                    <div className="weekendDay border px-2">
                        <small>1</small>
                    </div>
                    <div className="px-2">
                        <small>{window.translations.calendarLegend.weekend}</small>
                    </div>
                </div>
                <div className="d-flex align-items-center py-1 me-1">
                    <div className="selectedDay border px-2">
                        <small>1</small>
                    </div>
                    <div className="px-2">
                        <small>{window.translations.calendarLegend.selected}</small>
                    </div>
                </div>
                <div className="d-flex align-items-center py-1 me-1">
                    <div className="disabledDay border px-2">
                        <small>1</small>
                    </div>
                    <div className="px-2">
                        <small>{window.translations.calendarLegend.disabled}</small>
                    </div>
                </div>
            </div>
            <DateRange
                onChange={item => setState(item.selection)}
                locale={locale}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={[state]}
                direction={deviceSize < 768 ? "vertical" : "horizontal"}
                disabledDates={disabledDates}
                showMonthAndYearPickers={false}
                minDate={new Date()}
                possibleLengths={possibleLengths}
                dayContentRenderer={customDayContent}
                dragSelectionEnabled={false}
                onShownDateChange={fetchCalendarData}
                shownDate={shownDate}
                minLength={minLength}
                fixedLength={props.fixedLength}
                color={color}
                rangeColors={[color]}

                // fix - calendar is focusing on selected range on every render:


            />
            <div className="d-flex justify-content-between align-items-center some-info">
                {props.hideInfo ? null : someInfo}
            </div>
        </div>);
}

export const AddToCartButton = (props) => {
    const baseLink = window.links.reservation.new;

    let productId = props.productId;

    useEffect(() => {
        if (props.onDateConfirmed && props.startDate && props.endDate) {
            props.onDateConfirmed(props.startDate, props.endDate, props.officeId);
        }

    }, [props.startDate, props.endDate]);
    if (props.addToCartLabel === false) { // Explicitly set to false
        return;
    }

    let addToCartLabel = props.addToCartLabel ? props.addToCartLabel : window.translations.addToCart;

    if (!props.startDate || !props.endDate) {

        return (<div>
                <br/>
                <a type="button" className="btn btn-primary disabled">{addToCartLabel}&nbsp;&nbsp;&nbsp;<i
                    className="fas fa-chevron-right"></i></a>
                <br/>
                <br/>
            </div>);
    }

    const startDate = moment(props.startDate).format('YYYY-MM-DD');
    const length = moment(props.endDate).diff(moment(props.startDate), 'days') + 1;

    let url = new URL(baseLink);
    url.searchParams.append('date', startDate);
    url.searchParams.append('length', length);
    url.searchParams.append('productId', productId);
    url.searchParams.append('officeId', props.officeId);
    if (props.packageId) {
        url.searchParams.append('packageId', props.packageId);
    }
    const urlHref = url.toString();

    let aProps = {
        href: urlHref,
    };

    if (props.onDateConfirmed) {

        aProps = {
            onClick: (e) => {
                e.preventDefault();
                props.onDateConfirmed(startDate, length, props.officeId);
            }
        }
    }

    return (<div>
            <br/>
            <a {...aProps} type="button" className="btn btn-primary">{addToCartLabel}&nbsp;&nbsp;&nbsp;<i
                className="fas fa-chevron-right"></i></a>
            <br/>
            <br/>
        </div>);
}

const PriceInfo = (props) => {
    if (!props.startDate || !props.endDate) {
        return null;
    }

    const [loading, setLoading] = useState(true);

    const endPoint = window.api.product.getPricing;
    const [productId, setProductId] = useState(props.productId);

    const dateFromFormatted = moment(props.startDate).format('DD. MM. YYYY');
    const dateToFormatted = moment(props.endDate).format('DD. MM. YYYY');

    const url1 = endPoint + '?id=' + productId + '&dateTo=' + moment(props.endDate).format('YYYY-MM-DD') + '&dateFrom=' + moment(props.startDate).format('YYYY-MM-DD') + '&officeId=' + props.officeId + '&locale=' + window.variables.locale;

    const [deposit, setDeposit] = useState(null);
    const [price, setPrice] = useState(0);
    const [priceVat, setPriceVat] = useState(0);
    const [displayUnit, setDisplayUnit] = useState(null);
    const [pricePerDayFormatted, setPricePerDayFormatted] = useState(null);
    const [length, setLength] = useState(null);

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = () => {
            var response = fetch(url1, {signal: signal});

            response.then(response => response.json())
                .then(data => {
                    setLoading(false);
                    setPrice(data.priceTotalFormatted);
                    setPriceVat(data.priceTotalVatFormatted);
                    setDisplayUnit(data.displayUnit);
                    setPricePerDayFormatted(data.pricePerDayFormatted);
                    setLength(data.length);
                    if (data.depositFormatted) {
                        setDeposit(data.depositFormatted);
                    }
                    else {
                        setDeposit(null);
                    }
                })
                .catch(error => {
                    console.error(error);
                    setTimeout(() => {
                        fetchData();
                    }, 1000);
                });
        };

        fetchData();

        return () => controller.abort();

    }, [props.startDate, props.endDate]);


    if (loading) {
        return (<div style={{marginRight: "1em", color: "rgb(64,64,64)"}}>
                {window.translations.loading}
            </div>);
    }

    if (price === false) {
        return (<div style={{marginRight: "1em", color: "rgb(64,64,64)"}}>
            </div>);
    }

    let daysWord = '';
    let priceDisplay = price;
    if (length == 1) {
        daysWord = 'den';
    } else if (length > 1 && length < 5) {
        daysWord = 'dny';
    } else {
        daysWord = 'dní';
    }
    let forDays = ' za ' + length + ' ' + daysWord;

    if (window.variables.configCalculateExtraVat) {
        priceDisplay = price + " " + window.translations.priceWithoutVat;
        if (displayUnit) {
            priceDisplay += " / " + displayUnit;
        }
    }

    let priceVatDisplay = priceVat + " " + window.translations.priceWithVat;
    if (displayUnit) {
        priceVatDisplay += " / " + displayUnit;
        forDays = '';
    }


    return (<div className={'d-flex flex-grow-1 justify-content-end'}>
            {!displayUnit && <div style={{marginRight: "1em"}} className={'flex-grow-1 text-start'}>
                <br/>
                <div style={{fontSize: "1.2em", fontWeight: "normal"}}>
                      <span style={{fontSize: "0.8em", color: "rgb(64, 64, 64)", fontWeight: "bold"}}
                            className={'mb-2'}>

                          {pricePerDayFormatted} <span style={{fontWeight: "normal"}}>bez DPH / den</span>

                      </span>
                    <br/>
                </div>
                {/*<div style={{fontSize: "0.8em", color: "rgb(64, 64, 64)"}}>{dateFromFormatted} - {dateToFormatted}</div>*/}
                <br/>
            </div>}
            <div style={{marginRight: "1em"}}>
                <br/>
                <div style={{fontSize: "1.2em", fontWeight: "bold"}}>
                    {priceDisplay}<span style={{ fontWeight: "normal"}}>{forDays}</span>
                    <br/>
                    <span style={{
                        fontSize: "0.8em", color: "rgb(64, 64, 64)", fontWeight: "normal"
                    }}>{priceVatDisplay}{forDays}</span>
                </div>
                {/*<div style={{fontSize: "0.8em", color: "rgb(64, 64, 64)"}}>{dateFromFormatted} - {dateToFormatted}</div>*/}

                {deposit && <span style={{
                    fontSize: "0.8em", color: "rgb(64, 64, 64)", fontWeight: "normal"
                }}>
                    Vratná kauce: {deposit}
                </span>}
                <br/>
            </div>

        </div>);
}


export default ItemDatePicker;
